import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../hooks";
import {
  clearHabitationalRiskLocation,
  fetchHabitationalRiskListAsync,
  fetchHabitationalRiskAsync,
} from "../../../../../../redux/habitationalPolicy/habitationalRiskLocation/habitationalRiskLocationActions";

export const useHabitationalPolicyRiskLocation = (
  customerPolicyId?: number,
  incrementalNumber?: number
) => {
  const dispatch = useDispatchWrapper();
  const { data: riskLocations, risklocation } = useSelector(
    (storeState: IStoreState) => storeState.habitational.riskLocation
  );

  const riskLocationsDropDown = React.useMemo(() => {
    return riskLocations.map((item) => ({
      label: `${item.incremental_number} (${item.address}, ${item.city}, ${item.province_or_state}, ${item.postal_code})`,
      value: String(item.incremental_number || ""),
    }));
  }, [riskLocations]);

  const refreshData = () => {
    if (customerPolicyId) {
      if (incrementalNumber !== undefined) {
        dispatch(fetchHabitationalRiskAsync(customerPolicyId, incrementalNumber));
      } else {
        dispatch(fetchHabitationalRiskListAsync(customerPolicyId, "ACTIVE"));
      }
    }
  }

  React.useEffect(() => {
    if (customerPolicyId) {
      if (incrementalNumber !== undefined) {
        dispatch(fetchHabitationalRiskAsync(customerPolicyId, incrementalNumber));
      } else {
        dispatch(fetchHabitationalRiskListAsync(customerPolicyId, "ACTIVE"));
      }
    }

    return () => {
      dispatch(clearHabitationalRiskLocation());
    };
  }, [customerPolicyId, incrementalNumber]);

  return {
    riskLocationsDropDown,
    riskLocations,
    risklocation, // returning the selected/single risk location
    refreshData
  };
};
